import { motion } from 'framer-motion'
import { MapPin, Users, Code } from 'lucide-react'
import { cooperationModes } from '../data'
import { Card, CardContent, CardHeader, CardTitle, CardDescription, Button, Input, Textarea } from '../components/common'

export function CooperationPage() {
  const getIcon = (icon: string) => {
    switch (icon) {
      case 'map-pin': return <MapPin className="w-8 h-8 text-primary-500" />;
      case 'users': return <Users className="w-8 h-8 text-primary-500" />;
      case 'code': return <Code className="w-8 h-8 text-primary-500" />;
      default: return null;
    }
  }

  return (
    <>
      <section className="relative h-60 bg-gray-900 text-white">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(/images/cooperation-banner.jpg)` }}></div>
        <div className="container-custom h-full flex items-center relative z-10">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">商务合作</h1>
            <p className="text-lg text-white/80">携手共建书香云库生态</p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-3xl md:text-4xl font-bold mb-4"
            >
              合作模式
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-lg text-gray-600 max-w-2xl mx-auto"
            >
              我们提供多种合作模式，欢迎与我们一起携手共进，共创美好未来
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {cooperationModes.map((mode, index) => (
              <motion.div
                key={mode.id}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <Card className="h-full">
                  <CardHeader>
                    <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mb-4">
                      {getIcon(mode.icon)}
                    </div>
                    <CardTitle>{mode.title}</CardTitle>
                    <CardDescription>{mode.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2 mb-6">
                      {mode.benefits.map((benefit, i) => (
                        <li key={i} className="flex items-center space-x-2 text-sm text-gray-600">
                          <span className="w-1.5 h-1.5 bg-primary-500 rounded-full flex-shrink-0" />
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                    <Button className="w-full">
                      了解详情
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-3xl md:text-4xl font-bold mb-4"
            >
              合作申请
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-lg text-gray-600 max-w-2xl mx-auto"
            >
              填写以下表单，我们将尽快与您联系
            </motion.p>
          </div>

          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto"
          >
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">姓名</label>
                  <Input placeholder="请输入您的姓名" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">电话</label>
                  <Input placeholder="请输入您的联系电话" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">公司名称</label>
                <Input placeholder="请输入公司名称" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">合作模式</label>
                <Input placeholder="请选择合作模式" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">合作需求</label>
                <Textarea placeholder="请详细描述您的合作需求" />
              </div>
              <Button className="w-full">
                提交申请
              </Button>
            </form>
          </motion.div>
        </div>
      </section>
    </>
  )
}
